// Frontend Config
export const GET_CLIENT_CONFIG = 'GET_CLIENT_CONFIG';
export const SET_CLIENT_CONFIG = 'SET_CLIENT_CONFIG';
export const CLEAR_CLIENT_CONFIG = 'CLEAR_CLIENT_CONFIG';



// User actions
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGOUT = 'LOGOUT';
export const AUTH = 'AUTH';
export const LOGIN = 'LOGIN';

// DARK MODE
export const SET_MODE = 'SET_MODE';

// DATA
export const GET_DATA = 'GET_DATA';


// DASHBOARD
export const REQUEST_DASHBOARD = 'REQUEST_DASHBOARD';
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAILED = 'DASHBOARD_FAILED';

export const REQUEST_HEALTH_DASHBOARD = 'REQUEST_HEALTH_DASHBOARD';
export const HEALTH_DASHBOARD_SUCCESS = 'HEALTH_DASHBOARD_SUCCESS';
export const HEALTH_DASHBOARD_FAILED = 'HEALTH_DASHBOARD_FAILED';

export const REQUEST_OUTDOOR_DASHBOARD = 'REQUEST_OUTDOOR_DASHBOARD';
export const OUTDOOR_DASHBOARD_SUCCESS = 'OUTDOOR_DASHBOARD_SUCCESS';
export const OUTDOOR_DASHBOARD_FAILED = 'OUTDOOR_DASHBOARD_FAILED';

export const REQUEST_SAFETY_DASHBOARD = 'REQUEST_SAFETY_DASHBOARD';
export const SAFETY_DASHBOARD_SUCCESS = 'SAFETY_DASHBOARD_SUCCESS';
export const SAFETY_DASHBOARD_FAILED = 'SAFETY_DASHBOARD_FAILED';

export const REQUEST_PERFORMANCE_DASHBOARD = 'REQUEST_PERFORMANCE_DASHBOARD';
export const PERFORMANCE_DASHBOARD_SUCCESS = 'PERFORMANCE_DASHBOARD_SUCCESS';
export const PERFORMANCE_DASHBOARD_FAILED = 'PERFORMANCE_DASHBOARD_FAILED';

export const REQUEST_SECURITY_DASHBOARD = 'REQUEST_SECURITY_DASHBOARD';
export const SECURITY_DASHBOARD_SUCCESS = 'SECURITY_DASHBOARD_SUCCESS';
export const SECURITY_DASHBOARD_FAILED = 'SECURITY_DASHBOARD_FAILED';

// Health
export const REQUEST_HEALTH_DATA = 'REQUEST_HEALTH_DATA';
export const HEALTH_DATA_SUCCESS = 'HEALTH_DATA_SUCCESS';
export const HEALTH_DATA_FAILED = 'HEALTH_DATA_FAILED';

// Outdoor
export const REQUEST_OUTDOOR_DATA = 'REQUEST_OUTDOOR_DATA';
export const OUTDOOR_DATA_SUCCESS = 'OUTDOOR_DATA_SUCCESS';
export const OUTDOOR_DATA_FAILED = 'OUTDOOR_DATA_FAILED';

// Performance
export const REQUEST_PERFORMANCE_DATA = 'REQUEST_PERFORMANCE_DATA';
export const PERFORMANCE_DATA_SUCCESS = 'PERFORMANCE_DATA_SUCCESS';
export const PERFORMANCE_DATA_FAILED = 'PERFORMANCE_DATA_FAILED';

// Security
export const REQUEST_SECURITY_DATA = 'REQUEST_SECURITY_DATA';
export const SECURITY_DATA_SUCCESS = 'SECURITY_DATA_SUCCESS';
export const SECURITY_DATA_FAILED = 'SECURITY_DATA_FAILED';

// Admin - User
export const GET_USERSLIST = 'GET_USERSLIST';
export const GET_USER = 'GET_USER';
export const CLEAR_USER = 'CLEAR_USER';

export const GET_CLIENTSLIST = 'GET_CLIENTSLIST';
export const GET_CLIENT = 'GET_CLIENT';
export const SET_CLIENT = 'SET_CLIENT';
export const CLEAR_CLIENT = 'CLEAR_CLIENT';

export const GET_BUILDINGSLIST = 'GET_BUILDINGSLIST';
export const GET_BUILDING = 'GET_BUILDING';
export const SET_BUILDING = 'SET_BUILDING';
export const SET_BUILDING_DASHBOARD = 'SET_BUILDING_DASHBOARD'
export const CLEAR_BUILDING = 'CLEAR_BUILDING';

export const GET_FLOORSLIST = 'GET_FLOORSLIST';
export const GET_FLOOR = 'GET_FLOOR';
export const SET_FLOOR = 'SET_FLOOR';
export const SET_FLOOR_DASHBOARD = 'SET_FLOOR_DASHBOARD'
export const CLEAR_FLOOR = 'CLEAR_FLOOR';

export const GET_ROOMSLIST = 'GET_ROOMSLIST';
export const GET_ROOM = 'GET_ROOM';
export const SET_ROOM = 'SET_ROOM';
export const CLEAR_ROOM = 'CLEAR_ROOM';

export const GET_CONFIGS = 'GET_CONFIGS';
export const MODIFY_CONFIGS = 'MODIFY_CONFIGS';
export const CLEAR_CONFIGS = 'CLEAR_CONFIGS';

// Project
export const GET_PROJECTLIST ='GET_PROJECTLIST';
export const GET_PROJECT = 'GET_PROJECT';
export const SET_PROJECT = 'SET_PROJECT';
export const SET_PROJECT_DASHBOARD = 'SET_PROJECT_DASHBOARD';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';

// Deployment
export const GET_DEPLOYMENTLIST = 'GET_DEPLOYMENTLIST';
export const GET_DEPLOYMENT = 'GET_DEPLOYMENT';
export const SET_DEPLOYMENT = 'SET_DEPLOYMENT';
export const SET_DEPLOYMENT_DASHBOARD = 'SET_DEPLOYMENT_DASHBOARD';
export const CLEAR_DEPLOYMENT = 'CLEAR_DEPLOYMENT';

// Device
export const GET_DEVICELIST = 'GET_DEVICELIST';
export const GET_DEVICE = 'GET_DEVICE';
export const SET_DEVICE = 'SET_DEVICE';
export const SET_DEVICE_DASHBOARD = 'SET_DEVICE_DASHBOARD';
export const CLEAR_DEVICE = 'CLEAR_DEVICE';


// Task - Report Generator
export const REQUEST_GENERATE_REPORT = 'REQUEST_GENERATE_REPORT';
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';
export const GENERATE_REPORT_IN_PROGRESS = 'GENERATE_REPORT_IN_PROGRESS';
export const GENERATE_REPORT_FAILED = 'GENERATE_REPORT_FAILED';

export const CLEAR_ADMIN = 'CLEAR_ADMIN';

// Alerts actions
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// 3D Fusion actions
export const GET_3D_MODEL_URL = 'GET_3D_MODEL_URL';
export const SET_3D_MODEL_URL = 'SET_3D_MODEL_URL';
export const CLEAR_3D_MODEL_URL = 'CLEAR_3D_MODEL_URL';
export const GET_2D_MODEL_URL = 'GET_2D_MODEL_URL';
export const SET_2D_MODEL_URL = 'SET_2D_MODEL_URL';
export const CLEAR_2D_MODEL_URL = 'CLEAR_2D_MODEL_URL';
export const GET_360VIEW_MODEL_URL = 'GET_360VIEW_MODEL_URL';
export const SET_360VIEW_MODEL_URL = 'SET_360VIEW_MODEL_URL';
export const CLEAR_360VIEW_MODEL_URL = 'CLEAR_360VIEW_MODEL_URL';


export const GET_SCAN_INFO = 'GET_SCAN_INFO';
export const CLEAR_SCAN_INFO = 'CLEAR_SCAN_INFO';
